import { CanvasProps } from '@editor/interfaces/editor'

const useConfigProps = (props?: Partial<CanvasProps>): Required<CanvasProps> => ({
  pointClouds: props?.pointClouds ?? [],
  showLabels: props?.showLabels ?? true,
})

export default useConfigProps
